import axios from 'axios'
import { API_URL } from '@/utils/constants'

export const getEmployees = (params = {}, headers = {}) => {
  return axios.get(`${API_URL}/employee`, {
    params,
    headers: { ...headers }
  })
}
